import MenuItemComponent from "components/Editorial/ActionsMenu/MenuItemComponent";
import MenuItemType from "components/Editorial/ActionsMenu/PropTypes/MenuItemType";
import PropTypes from "prop-types";
import React from "react";
import ReactMenuItemType from "components/Editorial/ActionsMenu/PropTypes/ReactMenuItemType";
import { remove } from "lodash";

export default function MenuList({ items }) {
  const dangerousItems = remove(items, item => item.group === "dangerous");
  const menuItems = items.map(item => MenuItemComponent.for(item));
  const dangerousMenuItems = dangerousItems.map(item => MenuItemComponent.for(item));

  return (
    <ul>
      {menuItems}
      <li className="dangerous">
        <ul>
          {dangerousMenuItems}
        </ul>
      </li>
    </ul>
  );
}

MenuList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([MenuItemType, ReactMenuItemType])
  ).isRequired,
};
